import { render, staticRenderFns } from "./pageMenu.vue?vue&type=template&id=41d768fa"
import script from "./pageMenu.vue?vue&type=script&lang=js"
export * from "./pageMenu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports